var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.3747L9.42493 11.9093C9.86901 12.1906 10.4124 11.7748 10.2956 11.249L9.65281 8.36318L11.7973 6.41892C12.1888 6.0643 11.9784 5.39176 11.4642 5.34896L8.64194 5.09829L7.53757 2.37143C7.33891 1.87619 6.66109 1.87619 6.46243 2.37143L5.35806 5.09217L2.5358 5.34285C2.0216 5.38565 1.81124 6.05819 2.20273 6.4128L4.34719 8.35707L3.70444 11.2429C3.58757 11.7687 4.13099 12.1845 4.57507 11.9032L7 10.3747Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.37526a93.svg";
export { ForwardRef as ReactComponent };